import { createErrorFromResponse, FailToFetchError, getContentFromResponse } from '@magicdoorinc/errors';
import { MagicRequest } from '../network/magicRequest';
import { NetworkManager } from '../network/networkManager';

type QueryValue = string | number | readonly string[] | undefined;

export class Gateway {
  protected networkManager: NetworkManager;

  constructor(networkManager: NetworkManager) {
    this.networkManager = networkManager;
  }

  protected sendRequest = async (request: MagicRequest): Promise<Response> => {
    const response = await this.networkManager.sendRequest(request).catch(() => {
      throw new FailToFetchError();
    });
    if (response.ok) {
      return response;
    }

    throw createErrorFromResponse(response.status, await getContentFromResponse(response));
  };

  protected urlWithQuery(url: string, queries: Readonly<Record<string, QueryValue>>): string {
    const search = new URLSearchParams();
    for (const [name, value] of Object.entries(queries)) {
      if (value === undefined) continue;
      for (const each of Array.isArray(value) ? value : [value]) search.append(name, String(each));
    }
    return `${url}?${search}`;
  }

  protected createCommonHeaders = (): Headers => {
    const headers: Headers = new Headers();
    headers.append('content-type', 'application/json;charset=UTF-8');
    return headers;
  };
}
